export default "<!-- main application wrapper -->\n<section>\n    <ui-view></ui-view>\n</section>\n";